<template lang="pug">
div.page
  disable(v-if="display === 'Disable'")
  live-stream(v-else-if="display === 'LiveStream'" :user-device="userDevice" @changeImageStream="changeImageStream")
  image-stream(v-else-if="display === 'ImageStream'" :user-device="userDevice" @changeLiveStream="changeLiveStream")
  footer-nav(:useHelpButton="useHelpButton")
</template>

<script>
import LiveStream from "@/components/LiveStream";
import ImageStream from "@/components/ImageStream";
import Disable from "@/components/Disable";
import platform from "platform";
import FooterNav from "@/components/FooterNav";

export default {
  name: "Index",
  components: {
    LiveStream: LiveStream,
    ImageStream: ImageStream,
    Disable: Disable,
    FooterNav: FooterNav
  },
  data() {
    const display = this.browserJudgement(
      platform.name,
      platform.version,
      platform.os.family
    );
    return {
      display: display,
      useHelpButton: display !== "Disable",
      userDevice: platform.os.family
    };
  },
  methods: {
    browserJudgement(browser, browserVersion, device) {
      const isDisabled = !["Android", "iOS"].includes(device);
      const isSafariLiveStream =
        browser === "Safari" && parseFloat(browserVersion) >= 11.0;
      const isAndroidLiveStream =
        ["Chrome", "Chrome Mobile"].includes(browser) &&
        parseFloat(browserVersion) >= 4.4;

      return isDisabled
        ? "Disable"
        : isSafariLiveStream || isAndroidLiveStream
        ? "LiveStream"
        : "ImageStream";
    },
    changeImageStream() {
      this.display = "ImageStream";
    },
    changeLiveStream() {
      this.display = "LiveStream";
    }
  }
};
</script>

<style lang="sass" scoped>
.page
  display: flex
  flex-direction: column
  min-height: 100vh
</style>
